/* eslint-disable import/first */
global.__webpack_public_path__ = window._env_.REACT_APP_APPLICATION_SUB_PATH;

import React from "react";
import ReactDOM from "react-dom";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@/assets/css/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@/plugins/FontAwesome";

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();